import React, { useState } from 'react';
import axios from 'axios';

const SubscriptionForm = ({ 
    titleColor = '#0b1c3b', 
    textColor = '#595959',
    subscribedTextColor = '#d2b521',
    backgroundColor = 'transparent'
}) => {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [subscribed, setSubscribed] = useState(false);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const response = await axios.post('https://qgold-n8n.off-chainventures.com/webhook/a0dc46f8-f87b-4678-8179-81e4ebbc06d2', {
                email: email
            });
            if (response.data && response.data.status === 'success') {
                setSubscribed(true);
            } else {
                console.error('Subscription failed:', response.data);
                alert('Subscription failed. You may already be subscribed.');
            }
        } catch (error) {
            console.error('Error subscribing:', error.response ? error.response.data : error.message);
            alert('An error occurred. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <style>{`
                .subscription-form-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    max-width: 500px;
                    margin: 0 auto;
                }
                .subscription-form-container h4 {
                    text-align: center;
                    width: 100%;
                }
                .subscription-form-container p {
                    text-align: center;
                    width: 100%;
                }
                .subscription-form-container form {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 25px;
                }
                .subscription-form-container input {
                    width: 100%;
                    text-align: center;
                }
                .subscription-form-container button {
                    width: auto;
                    min-width: 200px;
                }
            `}</style>
            <div className="subscription-form-container text-white">
                <h4 className="fw-bold mb-2" >Get Q-Gold News First</h4>
                <p className="mb-3">Sign up for the latest News & Press Releases.</p>
                {subscribed ? (
                    <p className="mb-0 fw-bold" style={{ color: subscribedTextColor, fontSize: '18px' }}>Subscribed</p>
                ) : (
                    <form onSubmit={handleSubscribe}>
                        <input
                            type="email"
                            className="form-control rounded-0"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{
                                borderColor: '#ddd',
                                padding: '10px 15px',
                                textAlign: 'center'
                            }}
                        />
                        <button
                            type="submit"
                            disabled={submitting}
                            className="btn rounded-0 mt-2"
                            style={{
                                backgroundColor: '#d2b521',
                                color: '#fff',
                                border: '1px solid #d2b521',
                                padding: '15px 30px',
                                fontWeight: 'bold'
                            }}
                        >
                            {submitting ? '...' : 'SUBSCRIBE'}
                        </button>
                    </form>
                )}
            </div>
        </>
    );
};

export default SubscriptionForm;

